import axios from "axios";
import { forceLogout, TOKEN_KEY } from "../contexts/AuthContext";
import { API_URL } from "./apiUrl";

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = { ...(config.headers || {}), Token: token };
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // Only log out if not already on the login page
    if (err?.response?.status === 401 && !window.location.pathname.includes("/login")) {
      forceLogout();
    }
    return Promise.reject(err);
  }
);

// The API's {"message": "..."}, or a generic line when there is none
export function errorMessage(err) {
  return err?.response?.data?.message || "Sunucuya ulaşılamadı.";
}

export default api;
